
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SubscriptionList} from '../../../shared/models/asp.types';
import * as util from '../../../shared/services/util.service';
import {AppointmentService} from '../../../shared/services/appointment.service';
import {DateTime} from 'luxon';
import {CurrencyPipe} from '@angular/common';
import {AppointmentType, IResponse, IServiceAppointment, LocationType} from '@signal/asp-data-commons';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import { TranslateService } from '@ngx-translate/core';
import { countryCd } from '../../../shared/services/util.service';

@Component({
  selector: 'app-confirm-appointment',
  templateUrl: './confirm-appointment.component.html',
  styleUrls: ['./confirm-appointment.component.scss']
})
export class ConfirmAppointmentComponent implements OnInit, OnDestroy {
  view = 'confirm';
  appointment: IServiceAppointment;
  makeModelYear = '2020 YARIS HATCHBACK';
  detailMap: { [key: string]: string } = {
    'service.time': '',
    'testDrive.vehicle': '',
    'serviceSchedule.advisor': '',
    'testDrive.services': '',
    'service.estimatedCost': '',
    'testDrive.coupons': '',
    'service.location': ''
  };

  appointmentId: string;
  private subs: SubscriptionList = {};

  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly route: ActivatedRoute,
    private readonly currencyPipe: CurrencyPipe,
    private bannerService:AspBannerService,
    private readonly translate: TranslateService,
    private readonly router: Router
  ) {
    const urlState = this.router.getCurrentNavigation()?.extras?.state as IServiceAppointment;
    if(urlState?.appointmentId) {
      this.appointment = urlState;
      this.setDetailMap(urlState);
    } else {
        this.subs.query = this.route.queryParams.subscribe(params => {
          this.appointmentId = params.id;

          if (this.appointmentId) {
            this.subs.getAppt = this.appointmentService.get(AppointmentType.SERVICE, this.appointmentId).subscribe((res: IResponse<IServiceAppointment>) => {
              if (res && res.data) {
                this.appointment = res.data;
                this.setDetailMap(res.data);
              }
            });
          }
        });
    }
  }

  setDetailMap(appointmentDetails: IServiceAppointment) {
        const isRemoteLocation = appointmentDetails.transportation.category === LocationType.REMOTE;

        const date = `${DateTime.fromISO(appointmentDetails.appointmentStartDate).toFormat('MMMM dd')}`;
        const time = appointmentDetails.timeSlotId;

        const dateTime = `${date} at ${time}`;

        const vehicle = appointmentDetails.vehicle;
        const advisorName = appointmentDetails.advisor.displayName;

        const customer = appointmentDetails.customer;

        const serviceAndCost = this.getServiceAndCost(appointmentDetails);

        let customerAddress = '';
        if (isRemoteLocation) {
          const custAdd = appointmentDetails.pickUpAddress;
          customerAddress = `otherTexts.weWillPickTheCarAt:\n${custAdd.addressLine1}, ${custAdd.addressLine2 ? custAdd.addressLine2 + ', ' : ''} ${custAdd.city}, ${custAdd.state} - ${custAdd.zip}`;
        }
        const index= vehicle.description.indexOf(" ");
        const model = vehicle.description.substr(index)
        this.makeModelYear = vehicle.year + ' ' + vehicle.model;
        this.makeModelYear = vehicle.year && vehicle.model ? this.makeModelYear : `VIN ${vehicle.vin}`;


        const dealershipAddress = `${appointmentDetails.dealer.addressShort}`;

        const vehicleInfo = this.getVehicleInfo(vehicle);
        const transportLocation = appointmentDetails.transportation;
        this.detailMap = {
          'service.time': dateTime,
          'serviceSchedule.advisor': advisorName,
          'testDrive.vehicle': vehicleInfo,
          'testDrive.services': serviceAndCost.services,
          'service.estimatedCost': `${(util.countryCd==='USA')?'':'MX'}${this.currencyPipe.transform(serviceAndCost.cost, 'USD', 'symbol')}`,
          'service.transportation': transportLocation?.label? this.translate.instant(`service.${transportLocation.label}`): '',
          'service.location': `${(isRemoteLocation ? customerAddress : dealershipAddress)}`
        };
}

  getServiceAndCost(appointmentDetails) {
    let services = '';
    let cost = 0;
    const lexusComplimentaryText = this.translate.instant('service.lexusComplimentaryMaintenance');
    const toyotaComplimentaryText = this.translate.instant('service.toyotaComplimentaryMaintenance');
    const coveredByToyotaCareText = this.translate.instant('service.coveredByToyotaCare');
    if (appointmentDetails.serviceRequests && appointmentDetails.serviceRequests.length > 0) {
      appointmentDetails.serviceRequests.map(s => s.details).forEach(t => {
        const serviceRequestPrice = t.pricing.final;
        const coveredByToyotaCare = t?.recommended?.isCoveredByToyotaCare;
        const displayName = t.displayName ? t.displayName : t.dmsDescription;
        services += `${displayName} - ${coveredByToyotaCare ? (appointmentDetails?.dealerCode?.startsWith('6') ?
          lexusComplimentaryText :
          (countryCd === 'MEX' ? toyotaComplimentaryText :
            coveredByToyotaCareText)) : this.getOpcodeDisplayPricing(t)}\n`;
        cost = cost + (!isNaN(serviceRequestPrice) && !coveredByToyotaCare ? this.getFinalPriceValue(serviceRequestPrice) : 0);;
      });
    }

    return { services, cost };
  }

  getFinalPriceValue(price) {
    let resPrice = price;
    if(typeof resPrice === 'string') {
        resPrice = parseFloat(price);
    }
    return resPrice;
}

  getVehicleInfo(vehicle) {
    let vehicleInfo = vehicle.model && vehicle.year ? `${vehicle.year} ${vehicle.model || ''}` : '';
    vehicleInfo = vehicleInfo ? `${vehicleInfo} \n` : vehicleInfo;
    vehicleInfo = vehicle.vin ? `${vehicleInfo}VIN ${vehicle.vin}` : vehicleInfo;

    return vehicleInfo;
  }

ngOnInit(): void {
  this.bannerService.hide();
}

ngOnDestroy(): void {
  util.unsubscribeSubscriptions(this.subs);
}
getOpcodeDisplayPricing(serviceOpcode){
  return this.opCodePricingTranslation(util.getOpcodeDisplayPricing(serviceOpcode));
}
opCodePricingTranslation(text){
  if(text){
    text = text.replace('Starts at', this.translate.instant('opcodeServiceManagement.startsAt'));
    text = text.replace('Ranges from', this.translate.instant('opcodeServiceManagement.rangesFrom'));
  }
  return text;
}
}
